import React from 'react';

import { Link } from 'react-router-dom'; 
import {
    Button,
    Card
} from 'semantic-ui-react';

import ConditionalWrapper from './ConditionalWrapper.js';
import Sandbox from './Sandbox.js';

function Question(details) {
    return (
        <Sandbox>
            <Card>
                <Card.Content>
                    <Card.Header>{ details.question }</Card.Header>
                    <Card.Description>
                        <ConditionalWrapper
                            condition={details.wrapper !== undefined}
                            wrapper={details.wrapper}
                        >
                            {details.answers.map(answer => (
                                <Link to={answer.link}><Button {...answer.properties}>{answer.text}</Button></Link>
                            ))}
                        </ConditionalWrapper>
                    </Card.Description>
                </Card.Content>
            </Card>
        </Sandbox>
    );
}

export default Question;
